import { Component } from '@angular/core';
import { OrderByPipe } from 'src/app/shared/pipes/order-by.pipe';
import { DropdownListRenderer } from 'src/app/shared/renderers/dropdown-list/dropdown-list.component';
import { Constants } from 'src/app/shared/utils/constants';

@Component({
  selector: 'app-substance-name-renderer',
  templateUrl: '../../../renderers/dropdown-list/dropdown-list.component.html',
  styleUrls: ['../../../renderers/dropdown-list/dropdown-list.component.css']
})
export class SubstanceNameRenderer extends DropdownListRenderer {
  constructor(orderByPipe: OrderByPipe) {
    super(orderByPipe);
  }

  override agInit(params: any): void {
    super.agInit(params);
    this.resolveSelectedValueBySubstanceType(params);
    this.addSelectedOptionIfNotInOptions(params);
  }

  override dropdownChange(value: any): void {
    if (this.isGroupRendered) return;
    const selectedOption = this.options?.find((o: any) => o[this.optionValue] === value);
    if (selectedOption?.type === Constants.SUBSTANCE_TYPES.FORMULATION) {
      this.params.data.formulationPk = value;
      this.params.data.substanceType = Constants.SUBSTANCE_TYPES.FORMULATION;
      this.params.data.moleculePk = undefined;
    } else {
      this.params.data.moleculePk = value;
      this.params.data.substanceType = Constants.SUBSTANCE_TYPES.ACTIVE;
      this.params.data.formulationPk = undefined;
    }
    this.params.data.modified = true;
    try {
      this.parent.dropDownSelectionChanged({
        linkParams: this.link ? { columns: [...this.link], rowNodes: [this.params.node] } : undefined,
        field: this.field,
        id: this.params.node.id,
        row: this.params.data,
        sourceValues: this.options,
        value: value,
        params: this.params,
      });
    } catch (e) { }
    try {
      this.params.context.componentParent.dropDownSelectionChanged({
        linkParams: this.link ? { columns: [...this.link], rowNodes: [this.params.node] } : undefined,
        field: this.field,
        id: this.params.node.id,
        row: this.params.data,
        sourceValues: this.options,
        value: value,
        params: this.params,
      });
    } catch (e) { }
  }

  private resolveSelectedValueBySubstanceType(params: any): void {
    const substanceType = params.data?.substanceType;
    if (substanceType === Constants.SUBSTANCE_TYPES.FORMULATION) {
      this.selectedValue = params.data.formulationPk ?? params.value;
    } else if (substanceType === Constants.SUBSTANCE_TYPES.ACTIVE || substanceType === undefined || substanceType === null) {
      this.selectedValue = params.data.moleculePk ?? params.value;
    }
  }

  private addSelectedOptionIfNotInOptions(params: any): void {
    if (!this.selectedValue) return;
    if (!this.options?.find((x: any) => x[this.optionValue] === this.selectedValue)) {
      const substanceType = params.data?.substanceType;
      const fallbackName = substanceType === Constants.SUBSTANCE_TYPES.FORMULATION
        ? params.formulationName
        : params.activeIngredient ?? params.moleculeName;
      if (fallbackName) {
        this.options.push({
          [this.optionValue]: this.selectedValue,
          [this.optionLabel]: fallbackName,
          type: substanceType ?? Constants.SUBSTANCE_TYPES.ACTIVE,
        });
      }
    }
  }
}
